module.exports = __webpack_public_path__ + "img/logo-kid.35affe8a.png";